import { Box, Tooltip, Typography } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { useTranslate } from 'react-admin';

// Shown when the API returned the last successful result because OpenSearch timed out
const StaleDataAlert = ({
    stale,
    cachedAt,
}: {
    stale?: boolean;
    cachedAt?: string | null;
}) => {
    const translate = useTranslate();
    if (!stale) return null;
    const time = cachedAt
        ? new Date(cachedAt).toLocaleTimeString('fi-FI', {
              hour: '2-digit',
              minute: '2-digit',
          })
        : '-';
    return (
        <Tooltip title={translate('statistics.stale.tooltip')}>
            <Box
                sx={{
                    px: 1,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.5,
                    color: 'text.secondary',
                }}
            >
                <HistoryIcon sx={{ fontSize: 14 }} />
                <Typography variant="caption">
                    {translate('statistics.stale.label', { time })}
                </Typography>
            </Box>
        </Tooltip>
    );
};

export default StaleDataAlert;
